import { render, staticRenderFns } from "./ZTickSvg.vue?vue&type=template&id=04f19018&scoped=true&"
import script from "./ZTickSvg.vue?vue&type=script&lang=js&"
export * from "./ZTickSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f19018",
  null
  
)

export default component.exports